import { JwtPayload } from 'jwt-decode'

export enum PathName {
  LandingPage = '/',
  Login = '/login',
  Map = '/map-view',
  Timeseries = '/timeseries',
  Upload = '/upload',
  Document = '/document',
  Event = '/event',
  DataPoint = '/data-point',
  ContactUs = '/contact-us',
  SilentRenewToken = '/auth/silent-callback',
}

export interface LoginFormValues {
  username: string
  password: string
  rememberMe: boolean
}

export interface InitialUser {
  username: string
  password: string
  rememberMe: boolean
}

export interface JwtToken extends JwtPayload {
  preferred_username: string
  name: string
  roles: string[]
  nbf: number
  exp: number
  iat: number
  iss: string
  token: string
}

export interface User {
  name: string
  email: string
  roles: string[]
  nbf: number
  expired: number
  iat: number
  token: string
  iss: string
  initial?: string
  preferred_username?: string
}

export enum VariantType {
  error = 'error',
  warning = 'warning',
  info = 'info',
  success = 'success',
}
